import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";
import Services from '../../api/service'

const serviceMenuGroups = [
    { title: 'Core IT Services', links: Services.slice(0, 4) },
    { title: 'Digital Solutions', links: Services.slice(4, 7) },
    { title: 'Advisory & Support', links: Services.slice(7, 10) },
];

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/'
    },
    {
        id: 2,
        title: 'About Us',
        link: '/about'
    },
    {
        id: 6,
        title: 'Profile',
        link: '/profile'
    },
    {
        id: 3,
        title: 'What we do',
        link: '/service',
        submenu: serviceMenuGroups.map((group, index) => ({
            id: 31 + index,
            title: group.title,
            links: group.links.map((service) => ({
                title: service.title,
                link: `/service/${service.slug}`,
            })),
        }))
    },
    {
        id: 4,
        title: 'Solutions',
        link: '/service',
    },
    {
        id: 5,
        title: 'Contact',
        link: '/contact',
    }
]

const MobileMenu = ({ onNavigate }) => {

    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        if (onNavigate) {
            onNavigate();
            return;
        }
        window.scrollTo(10, 0);
    }

    return (
        <ul className="main_menu_list clearfix">
            {menus.map((item, mn) => {
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="subMenu">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <Fragment key={i}>
                                                        <ListItem>
                                                            <span className="submenu_heading">{submenu.title}</span>
                                                        </ListItem>
                                                        {submenu.links && submenu.links.map((child, j) => (
                                                            <ListItem key={`${i}-${j}`}>
                                                                <Link onClick={ClickHandler} className="active"
                                                                    to={child.link}>{child.title}</Link>
                                                            </ListItem>
                                                        ))}
                                                    </Fragment>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                </Collapse>
                            </Fragment>
                            : <Link onClick={ClickHandler} className="active"
                                to={item.link}>{item.title}</Link>
                        }
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default MobileMenu;
